(function ($) {
    function initTabs($root) {
        if (!$root.length || $root.data("penegaTabsReady")) return;

        $root.data("penegaTabsReady", true);

        var $tabs = $root.find('[role="tab"]');
        var $panels = $root.find('[role="tabpanel"]');
        var $accordionTriggers = $root.find("[data-tab-accordion]");
        var accordionMedia = window.matchMedia
            ? window.matchMedia("(max-width: 767px)")
            : null;

        if (!$tabs.length || !$panels.length) return;

        function isAccordion() {
            return accordionMedia ? accordionMedia.matches : false;
        }

        function normalizeIndex(index) {
            var count = $tabs.length;
            if (index < 0) return count - 1;
            if (index >= count) return 0;
            return index;
        }

        function activate(index, focusTab) {
            index = normalizeIndex(index);

            $tabs.each(function (i) {
                var active = i === index;
                $(this)
                .toggleClass("penega-tabs__tab--active", active)
                .attr("aria-selected", active ? "true" : "false")
                .attr("tabindex", active ? "0" : "-1");
            });

            $panels.each(function (i) {
                var active = i === index;
                $(this)
                .toggleClass("penega-tabs__panel--active", active)
                .prop("hidden", !active && !isAccordion());
            });

            $accordionTriggers.each(function (i) {
                var active = i === index;
                $(this)
                .toggleClass("penega-tabs__accordion-trigger--active", active)
                .attr("aria-expanded", active ? "true" : "false");
            });

            if (focusTab) {
                $tabs.eq(index).trigger("focus");
            }
        }

        function deactivateAccordion() {
            $tabs
                .removeClass("penega-tabs__tab--active")
                .attr("aria-selected", "false")
                .attr("tabindex", "-1");

            $panels
                .removeClass("penega-tabs__panel--active")
                .prop("hidden", false);

            $accordionTriggers
                .removeClass("penega-tabs__accordion-trigger--active")
                .attr("aria-expanded", "false");
        }

        $root.on("click", '[role="tab"]', function () {
            activate($tabs.index(this), false);
        });

        $root.on("click", "[data-tab-accordion]", function () {
            var index = $accordionTriggers.index(this);

            if (isAccordion() && $(this).hasClass("penega-tabs__accordion-trigger--active")) {
                deactivateAccordion();
                return;
            }

            activate(index, false);
        });

        $root.on("keydown", '[role="tab"]', function (event) {
            var index = $tabs.index(this);
            var nextIndex = null;

            switch (event.key) {
                case "ArrowRight":
                case "ArrowDown":
                    nextIndex = index + 1;
                    break;
                case "ArrowLeft":
                case "ArrowUp":
                    nextIndex = index - 1;
                    break;
                case "Home":
                    nextIndex = 0;
                    break;
                case "End":
                    nextIndex = $tabs.length - 1;
                    break;
            }

            if (nextIndex === null) return;

            event.preventDefault();
            activate(nextIndex, true);
        });

        if (accordionMedia) {
            if (accordionMedia.addEventListener) {
                accordionMedia.addEventListener("change", function () {
                    var activeIndex = $tabs.index($tabs.filter(".penega-tabs__tab--active").first());
                    activate(activeIndex < 0 ? 0 : activeIndex, false);
                });
            } else if (accordionMedia.addListener) {
                accordionMedia.addListener(function () {
                    var activeIndex = $tabs.index($tabs.filter(".penega-tabs__tab--active").first());
                    activate(activeIndex < 0 ? 0 : activeIndex, false);
                });
            }
        }

        activate($tabs.index($tabs.filter(".penega-tabs__tab--active").first()), false);
    }

    $(window).on("elementor/frontend/init", function () {
        if (window.elementorFrontend && window.elementorFrontend.hooks) {
            window.elementorFrontend.hooks.addAction(
                "frontend/element_ready/penega-tabs.default",
                function ($scope) {
                    initTabs($scope.find("[data-penega-tabs]").first());
                }
            );
        }
    });
})(jQuery);
